export const getAuthenticationTokenState = (state: {
    authentication: { tokenState: string };
}) => state.authentication.tokenState;
